import { useEffect } from 'react'
import { eventComposedPathHasClass } from '@Utils/HasElementOrSomeParentTheClass'

export default function useClickOutsideListener(
  elementClass: string,
  setOpen: (newOpen: boolean) => void,
  open: boolean
): void {
  useEffect(() => {
    const handlePointerDown = (e: MouseEvent) => {
      if (!open) {
        return
      }
      if (eventComposedPathHasClass(e, elementClass)) {
        return
      }
      setOpen(false)
    }

    // Capture phase: runs before bubble handlers that call stopPropagation(),
    // so outside clicks still close dropdowns in the editor.
    document.addEventListener('mousedown', handlePointerDown, true)
    return () => {
      document.removeEventListener('mousedown', handlePointerDown, true)
    }
  }, [elementClass, setOpen, open])
}
